<template>
  <div style="padding: 0 10px">
    <ScanQuery @onQuery="queryCall" ph="输入分拣框编号">
    </ScanQuery>
    <div class="title">
      <span>可组合：</span>
      <div style="background-color: #048060;"></div>
    </div>
    <div style="width:100%" class="boxBlock">
      <div v-for="i in combinableList" :key="i" class="boxItem" style="background-color: #048060;" @click="getProductDetail(i)"><div>{{ i }}</div></div>
    </div>
    <div class="title">
      <span>使用中：</span>
      <div style="background-color: #f79a39;"></div>
    </div>
    <div style="width:100%" class="boxBlock">
      <div v-for="i in usingList" :key="i" class="boxItem" style="background-color: #f79a39;" @click="getProductDetail(i)"><span>{{ i }}</span></div>
    </div>
    <div class="title">
      <span>空闲中：</span>
      <div style="background-color: #d9d9d9;"></div>
    </div>
    <div style="width:100%" class="boxBlock">
      <div v-for="i in unUsedList" :key="i" class="boxItem" style="background-color: #d9d9d9;" @click="getProductDetail(i)"><span>{{ i }}</span></div>
    </div>
    <el-dialog title="商品明细" :visible.sync="productDetailVisible">
      <WmsTable :columns="columns" :dataSource="productDetail" :isPagination="false" :hasHeader=false></WmsTable>
    </el-dialog>
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import WmsTable from "@/components/WmsTable";
import { getBasketItem,selectPackBasket } from '@/apis/combination'

export default {
  name: "sortBox",
  components: {ScanQuery,WmsTable},
  data() {
    return {
      query: {
        code: '',
      },
      combinableList:[],
      unUsedList:[],
      usingList:[],
      productDetailVisible: false,
      productDetail: [],
      columns:[
        {
          title: "批次",
          dataIndex: "pkgCode",
          key: "pkgCode",
        },
        {
          title: "状态",
          dataIndex: "picked",
          key: "picked",
          customRender: (text, record) => {
            return text == 2 ?'已分拣':'未分拣'
          },
        },
        {
          title: "拣货批次",
          dataIndex: "pickCode",
          key: "pickCode",
        },
      ]
    }
  },
  computed: {
  },
  methods: {
    queryCall: function (payload) {
      this.getDetail(payload.code)
    },
    getDetail(code){
      selectPackBasket({basketCode:code}).then(({code,data})=>{
        if(code == 0 ){
          this.combinableList = data.combinableList
          this.unUsedList = data.unUsedList
          this.usingList = data.usingList
        }
      })
    },
    getProductDetail(code){
      getBasketItem({basketCode:code}).then(({code,data})=>{
        if(code == 0 ){
          this.productDetail = data
          this.productDetailVisible = true
        }
      })
    }
  },
  mounted(){
  },
  activated() {
    this.getDetail('')
  },
}
</script>

<style scoped>
.title{
  text-align: left;
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.title div{
  height: 20px;
  width: 40px;
  border-radius: 2px;
  margin-left: 10px;
}

.boxBlock{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.boxItem{
  padding: 0 20px;
  height: 60px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: 22px;
  margin: 5px 5px 0 0;
  cursor: pointer;
}

</style>